import { initSwiper } from '../../components/swiper';

const finishInjection = (containerEl) => {
  const sliderEl = containerEl.querySelector('[data-swiper-recommended-products]');
  if (!sliderEl) return;

  initSwiper(sliderEl);
  if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
    window.yotpoWidgetsContainer.initWidgets();
  }
};

const loadFallbackRecs = async (containerEl) => {
  const productsUrl = containerEl.dataset.url;
  if (!productsUrl) return;

  try {
    const response = await fetch(productsUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const html = await response.text();
    containerEl.innerHTML = html;
    finishInjection(containerEl);
  } catch (err) {
    console.error('Error fetching recommended products:', err);
  }
};

const loadAcsRecs = (containerEl) => {
  // The pdp_recs_2 element requires a numeric context product id ("product_id
  // was not supplied" warning otherwise). The product URL is passed as
  // page_context.page_url to make the strategy's page context explicit —
  // without it the strategy falls back to the x_page_url the library sends
  // (the current location), which only resolves on a matching product page.
  const contextProductId = containerEl.dataset.acsProductId;
  const contextProductUrl = containerEl.dataset.acsProductUrl;
  const hasGraphene = typeof window.graphenehc?.load === 'function';
  if (!hasGraphene || !contextProductId || !contextProductUrl) {
    loadFallbackRecs(containerEl);
    return;
  }

  window.graphenehc.load({
    elements: [{ id: 'pdp_recs_2', target: '[data-recommended-products]' }],
    // NOTE: request `args` never reach element template renders (verified
    // 2026-07-27) — the heading is applied client-side on success. Excluding
    // the context product is unnecessary: the element pipeline excludes it
    // server-side (verified same day).
    // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
    page_context: {
      // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
      currency_id: window.Shopify.currency.active,
      // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
      product_id: contextProductId,
      // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
      page_url: window.location.origin + contextProductUrl,
    },
    success: () => {
      if (!containerEl.querySelector('.swiper-slide')) {
        loadFallbackRecs(containerEl);
        return;
      }

      // AC ignores request args, so the section-setting heading is applied here
      // rather than in the element template (which renders its own default).
      const heading = containerEl.dataset.acsHeading;
      const headingEl = containerEl.querySelector('h2');
      if (heading && headingEl) headingEl.textContent = heading;

      finishInjection(containerEl);
    },
  });
};

const initRecommendedProducts = () => {
  const recommendedProductsEl = document.querySelector('[data-recommended-products]');
  if (!recommendedProductsEl) return;
  if (recommendedProductsEl.dataset.recsLoaded === 'true') return;
  recommendedProductsEl.dataset.recsLoaded = 'true';

  if (recommendedProductsEl.hasAttribute('data-acs-pdp-recs')) {
    loadAcsRecs(recommendedProductsEl);
  } else {
    loadFallbackRecs(recommendedProductsEl);
  }
};

export default initRecommendedProducts;
